import { KMLFile_Read } from '@treadinc/horizon-api-spec';

import { Nullable } from '~types/Nullable';

export class KMLFile {
  public static parse(proto: KMLFile_Read): KMLFile {
    return new KMLFile(proto.id, proto.name, proto.file_url, proto.file_name);
  }

  public get id() {
    return this._id;
  }

  public get name() {
    return this._name;
  }

  public get fileUrl() {
    return this._fileUrl;
  }

  public get fileName() {
    return this._fileName;
  }

  constructor(
    private _id: string,
    private _name: Nullable<string>,
    private _fileUrl: string,
    private _fileName: string,
  ) {}
}
